"use strict";

Vue.component("vue-multiselect", window.VueMultiselect.default);
var vm = new Vue({
  el: "#app",
  delimiters: ["%%", "%%"],
  data: function data() {
    return {
      cats: 4,
      country: "",
      ingredients: false,
      loaded: false,
      oldbundle: false,
      orderType: "single",
      photoIndex: 0,
      ppImgTest: false,
      popup: false,
      step: 1,
      upsell: true,
      upsell_taken: false,
      view: "original",
      weeks_long: "4 Weeks (Recommended)",
      debug: false,
      options: ["4 Weeks (Recommended)", "3 Weeks (Extra Odour Control)"]
    };
  },
  beforeMount: function beforeMount() {
    var self = this;
    function getParameterByName(name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    var step = getParameterByName("step");
    if (step !== null && step !== undefined) {
      self.step = step;
    }
    var type = "single";
    if (getParameterByName("ot") == "blk") {
      self.orderType = "multi";
    }
    //debug
    var debug = getParameterByName("debug");
    if (debug !== null && debug !== undefined) {
      self.debug = true;
    }
  },

  components: {
    Multiselect: window.VueMultiselect.default
  },
  mounted: function mounted() {
    console.log("Vue.js mounted");
    var self = this;
    function getParameterByName(name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    //check for # of cats in URL
    var cats = getParameterByName("cats");
    if (cats !== null && cats !== undefined) {
      console.log("Found " + cats + " cats in URL!");
      var cat_number = Number(cats);
      if (cat_number == 1) {
        this.cats = 1;
        this.step = 2;
      }
      if (cat_number == 2) {
        this.cats = 2;
        this.step = 2;
      }
      if (cat_number == 3 || cat_number == 4) {
        this.cats = 3;
        this.step = 2;
      }
    } else {
      window.location.hash = self.step;
    }

    //check for possible promotion in URL
    var promotion = getParameterByName("utm_campaign");
    if (promotion !== undefined && promotion !== null) {
      if (promotion.toLowerCase() == "laborday") {
        this.promotion = "laborday";
      }
    }
    //check for forceView in URL
    var forceView = getParameterByName("forceView");
    if (forceView !== null && forceView !== undefined) {
      this.view = forceView;
    }
    //geotracking stuff
    var getCookie = function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    };
    var country = getCookie("_plgeo");
    if (country !== undefined && country !== null) {
      console.log("SETTING COUNTRY!", country);
      this.country = country;
    } else {
      setTimeout(function () {
        console.log("TIMEOUT GET COOKIE");
        country = getCookie("_plgeo");
        if (country !== undefined && country !== null) {
          console.log("TIMEOUT RESULT: ", country);
          self.country = country;
        }
      }, 4500);
    }
    self.loaded = true;
  },

  computed: {
    weeks: function weeks() {
      return Number(this.weeks_long.charAt(0));
    },
    productOptions: function productOptions() {
      var arr = [];
      if (this.cats == 1) {
        var product = {
          vid: 34499799548037,
          cats: 1,
          price: 30,
          productType: "single"
        };
        arr.push(product);
      }
      if (this.cats == 2) {
        var _product = {
          vid: 34499799580805,
          cats: 2,
          price: 55,
          productType: "single"
        };
        arr.push(_product);
      }
      if (this.cats == 3) {
        var _product2 = {
          vid: 34499799613573,
          cats: 3,
          price: 82,
          productType: "single"
        };
        arr.push(_product2);
      }
      if (this.cats == 4) {
        var _product3 = {
          vid: 34499799646341,
          cats: 4,
          price: 109,
          productType: "single"
        };
        arr.push(_product3);
      }
      if (this.cats == 5) {
        var _product4 = {
          vid: 34499799679109,
          cats: 5,
          price: 136,
          productType: "single"
        };
        arr.push(_product4);
      }
      if (this.cats == 6) {
        var _product5 = {
          vid: 34499799711877,
          cats: 6,
          price: 164,
          productType: "single"
        };
        arr.push(_product5);
      }
      if (this.cats == 7) {
        var _product6 = {
          vid: 34499799777413,
          cats: 7,
          price: 191,
          productType: "single"
        };
        arr.push(_product6);
      }
      if (this.cats == 8) {
        var _product7 = {
          vid: 34499799810181,
          cats: 8,
          price: 218,
          productType: "single"
        };
        arr.push(_product7);
      }
      if (this.cats == 9) {
        var _product8 = {
          vid: 34499799842949,
          cats: 9,
          price: 245,
          productType: "single"
        };
        arr.push(_product8);
      }
      if (this.cats == 10) {
        var _product9 = {
          vid: 34499799875717,
          cats: 10,
          price: 272,
          productType: "single"
        };
        arr.push(_product9);
      }
      if (this.cats == 11) {
        var _product10 = {
          vid: 34499799908485,
          cats: 11,
          price: 300,
          productType: "single"
        };
        arr.push(_product10);
      }
      if (this.cats == 12) {
        var _product11 = {
          vid: 34499799941253,
          cats: 12,
          price: 327,
          productType: "single"
        };
        arr.push(_product11);
      }
      return arr;
    },
    cart: function cart() {
      var self = this;
      var cart = {};
      cart.quantity = 1;
      cart.id = getVid();
      cart.properties = {
        shipping_interval_frequency: self.weeks,
        shipping_interval_unit_type: "Weeks",
        subscription_id: 225784
      };
      function getVid() {
        if (self.cats == 1) {
          return 34499799548037;
        }
        if (self.cats == 2) {
          return 34499799580805;
        }
        if (self.cats == 3) {
          return 34499799613573;
        }
        if (self.cats == 4) {
          return 34499799646341;
        }
        if (self.cats == 5) {
          return 34499799679109;
        }
        if (self.cats == 6) {
          return 34499799711877;
        }
        if (self.cats == 7) {
          return 34499799777413;
        }
        if (self.cats == 8) {
          return 34499799810181;
        }
        if (self.cats == 9) {
          return 34499799842949;
        }
        if (self.cats == 10) {
          return 34499799875717;
        }
        if (self.cats == 11) {
          return 34499799908485;
        }
        if (self.cats == 12) {
          return 34499799941253;
        }
      }
      if (self.upsell_taken == true) {
        // cart.properties.bundle = "true";
        // cart.properties.bundle_discount = 0;
      }
      return cart;
    },
    discount: function discount() {
      var discount = null;
      if (this.cats == 1 && this.orderType == "multi") {
        discount = "MULTI5";
      }
      if (this.cats == 2 && this.orderType == "multi") {
        discount = "MULTI10";
      }
      if (this.cats == 3 && this.orderType == "multi") {
        discount = "MULTI15";
      }
      return discount;
    }
  },
  methods: {
    addItemsToCart: function addItemsToCart() {
      var self = this;
      console.log("Adding items to cart.");
      console.log("Upsell taken: " + self.upsell_taken);
      if (self.upsell_taken) {
        addFood();
      } else {
        addCart();
      }
      function addFood() {
        var food = {};
        if (self.orderType == "multi") {
          food = {
            id: 14177898758205,
            quantity: 1,
            properties: {
              shipping_interval_frequency: 4,
              shipping_interval_unit_type: "Weeks",
              subscription_id: 171263,
              recurring_price: 25.0
              //   bundle: "true",
              //   bundle_discount: 0
            }
          };
        } else {
          food = {
            id: 14177898758205,
            quantity: 1,
            properties: {
              shipping_interval_frequency: 4,
              shipping_interval_unit_type: "Weeks",
              subscription_id: 171263,
              recurring_price: 25.0
              //   bundle: "true",
              //   bundle_discount: 0
            }
          };
        }
        axios.post("/cart/add.js", food).then(function (response) {
          console.log("Food added to cart..");
          addCart();
        }).catch(function (error) {
          console.log(error);
        });
      }
      function addCart() {
        axios.post("/cart/add.js", self.cart).then(function (response) {
          console.log("Litter added to cart.");
          self.postEvents();
          self.goToCheckout();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    changeStep: function changeStep(step, obj) {
      if (step == 2 && this.step == 1) {
        // gtag("event", "continue_step_2", { event_category: "get_started" });
        ga("send", {
          hitType: "event",
          eventCategory: "get_started",
          eventAction: "continue_step_2"
        });
        console.log("1 -> 2");
      }
      if (step == 3 && this.step == 2) {
        // gtag("event", "continue_step_3", {
        //   event_category: "get_started",
        //   event_label: window.vm.cats + " Cats - " + window.vm.orderType,
        // });
        ga("send", {
          hitType: "event",
          eventCategory: "get_started",
          eventAction: "continue_step_3",
          eventLabel: this.cats + " Cats - " + this.orderType
        });
        console.log("2 -> 3");
        if (this.country == "US") {
          this.step = 3;
          window.location.hash = this.step;
          this.scrollTop();
        } else {
          this.startCheckout(obj);
        }
      } else {
        this.step = step;
        window.location.hash = this.step;
        this.scrollTop();
      }
    },
    changeThumbnail: function changeThumbnail(ndx, obj) {
      var self = this;
      console.log("changing thumbnail...");
      console.log(obj);
      var photoEl = document.getElementById("productImage");
      photoEl.style.minHeight = photoEl.clientHeight + "px";
      photoEl.style.minWidth = photoEl.clientWidth + "px";
      this.$nextTick(function () {
        // DOM is now updated
        // `this` is bound to the current instance
        this.photoIndex = ndx;
      });
    },
    clearCart: function clearCart() {
      var self = this;
      axios.post("/cart/clear.js").then(function (response) {
        console.log("Cart cleared.");
        self.addItemsToCart();
      }).catch(function (error) {
        console.log(error);
      });
    },
    goToCheckout: function goToCheckout() {
      var self = this;
      var token = undefined;
      function get_cookie(name) {
        return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
      }
      do {
        token = get_cookie("cart");
      } while (token == undefined);

      var myshopify_domain = "prettylitter-ca.myshopify.com";
      var ga_linker = "";
      try {
        ga_linker = ga.getAll()[0].get("linkerParam");
      } catch (err) {
        ga_linker = "";
      }
      var customer_param = "";
      if (self.discount !== null) {
        var checkout_url = "https://checkout.prettylitter.ca/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + "&discount=" + self.discount + "&" + customer_param;
        console.log(checkout_url);
        window.location.href = checkout_url;
      } else {
        var _checkout_url = "https://checkout.prettylitter.ca/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + "&" + customer_param;
        console.log(_checkout_url);
        window.location.href = _checkout_url;
      }
    },
    initializeSwiper: function initializeSwiper() {
      console.log("initializeSwiper.");
      setTimeout(function () {
        var mySwiper = new Swiper(".swiper-container", {
          direction: "horizontal",
          loop: false,
          slidesPerView: 3,
          autoHeight: true,
          noSwiping: true,
          noSwipingClass: "swiper-slide",
          spaceBetween: 20,
          breakpoints: {
            // when window width is <= 767px
            767: {
              noSwiping: false,
              slidesPerView: 1.25,
              spaceBetween: 10
            }
          },
          centeredSlides: true,
          initialSlide: 1
        });
      }, 650);
    },
    postEvents: function postEvents() {
      //pinterest
      if (typeof pintrk !== "undefined") {
        console.log("pintrk defined");
        pintrk("track", "addtocart", {
          value: 100,
          order_quantity: 1,
          currency: "USD"
        });
      }
    },
    scrollTop: function scrollTop() {
      $("html, body").animate({
        scrollTop: $("body").offset().top
      }, 500);
    },
    startCheckout: function startCheckout(obj) {
      console.log("startCheckout");
      if (!this.processing) {
        this.processing = true;
        if (this.upsell_taken == true && this.country == "US") {
          // gtag("event", "proceed_to_checkout", {
          //   event_category: "get_started",
          //   event_label: "add food",
          // });
          ga("send", {
            hitType: "event",
            eventCategory: "get_started",
            eventAction: "proceed_to_checkout",
            eventLabel: "add food"
          });
        }
        if (this.upsell_taken == false && this.country == "US") {
          // gtag("event", "proceed_to_checkout", {
          //   event_category: "get_started",
          //   event_label: "no food",
          // });
          ga("send", {
            hitType: "event",
            eventCategory: "get_started",
            eventAction: "proceed_to_checkout",
            eventLabel: "no food"
          });
        }
        if (this.country !== "US") {
          // gtag("event", "proceed_to_checkout", {
          //   event_category: "get_started",
          //   event_label: "food ineligible",
          // });
          ga("send", {
            hitType: "event",
            eventCategory: "get_started",
            eventAction: "proceed_to_checkout",
            eventLabel: "food ineligible"
          });
        }
        this.clearCart();
        if (this.step == 3) {
          if (this.upsell_taken !== false) {
            obj.target.innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
          } else {
            obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
          }
        } else {
          if (this.upsell_taken == true || this.step == 1) {
            obj.target.innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
          }
          if (this.upsell_taken == false || this.step == 2) {
            obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
          }
        }
      }
    },
    stepTwo: function stepTwo(obj) {
      var self = this;
      if (obj.target.id == "checkoutStep1") {
        document.getElementById(obj.target.id).innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
      }
      setTimeout(function () {
        if (self.toyUpsell == true && self.country == "US") {
          self.step = 2;
          window.scrollTo({ top: 0, behavior: "smooth" });
          self.initializeSwiper();
        } else {
          self.startCheckout;
        }
      }, 1500);
    },
    togglePopup: function togglePopup() {
      this.pricePopup = !this.pricePopup;
    }
  },
  filters: {
    getIcon: function getIcon(n) {
      var baseUrl = "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/";
      if (n == 1) {
        return baseUrl + "icon_v2_1cat@2x.png";
      }
      if (n == 2) {
        return baseUrl + "icon_v2_2cats@2x.png";
      }
      if (n == 3) {
        return baseUrl + "icon_v2_3cats@2x.png";
      }
    },
    getDiscount: function getDiscount(n) {
      if (n == 1) {
        return "$22";
      }
      if (n == 2) {
        return "$44";
      }
      if (n == 3) {
        return "$66";
      }
    },
    getPrice: function getPrice(n) {
      if (n == 1) {
        return "$22";
      }
      if (n == 2) {
        return "$40";
      }
      if (n == 3) {
        return "$60";
      }
    }
  }
});

//nonvue items

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}
function setCookie(name, value, expiration) {
  document.cookie = name + "=" + value + "; domain=prettylitter.ca; path=/; expires=" + expiration + ";";
}
var bfcm_cookie = getCookie("bfcm");
if (bfcm_cookie == undefined) {
  setCookie("bfcm19", "onebag", "Wed Dec 04 2019 00:00:00 GMT-0800");
}

function HashHandler() {
  if (window.vm.loaded) {
    if (window.location.hash !== "" && window.location.hash !== "#") {
      // console.log("The Hash has changed!");
      var hash = window.location.hash.split("#")[1];
      // console.log(hash, window.vm.step);
      window.vm.step = hash;
    }
  }
}

window.addEventListener("hashchange", HashHandler, false);